module.exports = __webpack_public_path__ + "static/flags/MD-48641011036e3e9bfbcf24d0ed2208c5.gif";